module.exports = "/_next/static/images/LeverageFacebookAds-3b5db41318dea788a097799d3e6525b8.webp";